module.exports = __webpack_public_path__ + "images/87488deaa7b693a21cdc115c1b0e0f7d.webp";